import React from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/edit_my_company_member_financial_rate_group_wizard/EditMyCompanyMemberFinancialRateGroupForm.scss';
import Button from '../../components/Button';
import { __, setTableParams } from '../../core/utils';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import Select from '../../components/Select';
import * as _ from 'lodash';
import Input from '../../components/Input';
import { connect } from 'react-redux';
import { map } from 'lodash';
import DateTimePicker from '../../components/DateTimePicker';

const EditMyCompanyMemberFinancialRateGroupForm = ({
  handleSubmit,
  submitting,
  localization,
}) => {
  const currency_options = map(localization?.currencies, (currency) => {
    return {
      value: currency.id,
      label: [currency.code, currency.name].join(' - '),
    };
  });

  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      {/* <div className={styles.flex}>
        <div className={styles.f1}>
          <label>{__('my_company_members.flyout.current-values')}</label>
        </div>
      </div> */}
      <div className={styles.form}>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              options={currency_options}
              name='rate_currency_id'
              component={Select}
              label={__('my_company_members.flyout.rate_currency')}
              searchable
            />
          </div>
          <div className={styles.f1} />
          <div className={styles.f1} />
        </div>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='hourly_rate'
              component={Input}
              label={__('my_company_members.flyout.hourly_rate')}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='chargeout_rate'
              component={Input}
              label={__('my_company_members.flyout.chargeout_rate')}
            />
          </div>
          <div className={styles.f1} />
        </div>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='rate_start_date'
              component={DateTimePicker}
              label={__('my_company_members.flyout.rate_start_date')}
              footer
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='rate_end_date'
              component={DateTimePicker}
              label={__('my_company_members.flyout.rate_end_date')}
              footer
            />
          </div>
          <div className={styles.f1}></div>
        </div>
      </div>

      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={() =>
            setTableParams('my_company_members', {
              edit_my_company_member_financial_rate_group_wizard: undefined,
            })
          }
        />
        <Button
          lightBlue
          medium
          right
          submit
          middleText={__('button.edit')}
          spinning={submitting}
        />
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    store: _.get(state.table, 'my_company_members'),
  };
};

export default withRouter(
  reduxForm({
    form: 'edit_my_company_member_financial_rate_group_wizard.edit_my_company_member_financial_rate_group',
  })(
    connect(
      mapStateToProps,
      null
    )(
      subscribe(
        Localization,
        'localization'
      )(EditMyCompanyMemberFinancialRateGroupForm)
    )
  )
);
